import { Link } from "react-router-dom";
import { Facebook, Instagram, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white mt-24">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="inline-flex bg-white rounded-md p-3 mb-5">
              <img src="/cdos-logo-mark.png" alt="CDOS — Centennial Dealership Operating System"
                className="h-16 w-auto" data-testid="footer-logo" />
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed text-sm">
              The complete dealership management, compliance, and operations platform — built from
              decades of real-world dealership, service, and fixed-ops experience.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://www.facebook.com/profile.php?id=61590701735780" target="_blank" rel="noreferrer"
                 data-testid="footer-facebook" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://instagram.com/centennialoperating" target="_blank" rel="noreferrer"
                 data-testid="footer-instagram" className="w-10 h-10 border border-white/15 flex items-center justify-center hover:bg-primary hover:border-primary transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Products</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/products/dealership-managers-toolkit" className="hover:text-white">Manager's Toolkit</Link></li>
              <li><Link to="/products/operations-library" className="hover:text-white">Operations Library</Link></li>
              <li><Link to="/products/cdos-complete" className="hover:text-white">CDOS Complete</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/resources" className="hover:text-white">Resources</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/login" className="hover:text-white">Customer Login</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Ready to systemize?</h4>
            <Link to="/products" data-testid="footer-cta"
              className="inline-flex items-center gap-1 bg-white text-black px-5 py-3 font-semibold text-sm btn-lift">
              Explore the System <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Centennial Business Systems · centennialdealershipsystem.com</span>
          <span>CDOS · CCOS · CHRS</span>
        </div>
      </div>
    </footer>
  );
}
